import { PaginationComponent } from '../../common';
import { useDispatch, useSelector } from 'react-redux';
import { selectPagination, setPage } from 'ducks/vehicles/common';
import React from 'react';

export const Pagination = (props: unknown) => {
    const dispatch = useDispatch();

    const pagination = useSelector(selectPagination);

    const handleSetPage = React.useCallback(
        (page: number) => {
            dispatch(setPage({ page }));
        },
        [dispatch],
    );
    return (
        <PaginationComponent
            {...props}
            pagination={pagination}
            setPage={handleSetPage}
        />
    );
};
